import { render, staticRenderFns } from "./FormBuilderElementPropertiesManager.vue?vue&type=template&id=f425c104&"
import script from "./FormBuilderElementPropertiesManager.vue?vue&type=script&lang=js&"
export * from "./FormBuilderElementPropertiesManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../Breeze.Kiosk.Frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports